/**
 * Tujuan setelah login untuk halaman yang dibuka dari kartu inbox mobile.
 *
 * Tanpa sesi, rute halaman approval belum ada (rute dibangun dari menu yang
 * baru tersimpan setelah login), jadi `ContentRoutes` melempar ke `/login` dan
 * `?id=&embed=true` hilang; login dari cookie lalu memuat ulang `/login`.
 * Sebelum dilempar, halaman yang dituju dicatat di sini, dan sesudah login App
 * pindah ke sana.
 *
 * Hanya di embed: di peramban biasa tidak ada yang dicatat, jadi login tetap
 * memuat ulang halaman seperti sebelumnya.
 */

export const KUNCI_TUJUAN = 'embedTujuan';

/** Hanya path relatif aplikasi ini; `//host` (open redirect) ditolak. */
const relatif = (nilai) =>
	typeof nilai === 'string' && nilai.startsWith('/') && !nilai.startsWith('//');

/**
 * @param {{pathname: string, search?: string, hash?: string}} loc
 * @param {boolean} isEmbed
 * @param {Storage} [storage]
 * @returns {boolean} true bila tujuan tercatat
 */
export const simpanTujuanEmbed = (loc, isEmbed, storage = window.localStorage) => {
	if (!isEmbed || !loc) return false;
	const tujuan = `${loc.pathname || ''}${loc.search || ''}${loc.hash || ''}`;
	if (!relatif(tujuan) || tujuan === '/' || tujuan.startsWith('/login')) return false;
	try {
		storage.setItem(KUNCI_TUJUAN, tujuan);
		return true;
	} catch (e) {
		return false;
	}
};

/**
 * Baca sekali pakai: langsung dihapus setelah dibaca.
 * @param {Storage} [storage]
 * @returns {string|null}
 */
export const ambilTujuanEmbed = (storage = window.localStorage) => {
	try {
		const tujuan = storage.getItem(KUNCI_TUJUAN);
		storage.removeItem(KUNCI_TUJUAN);
		return relatif(tujuan) && !tujuan.startsWith('/login') ? tujuan : null;
	} catch (e) {
		return null;
	}
};
